import React, { useState } from "react";
import { AiOutlineCloudUpload, AiOutlineCheckCircle } from "react-icons/ai";
import "./ActivitiesAndProjects.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LessonProjects = ({
  title,
  projects,
  backgroundColor,
  textColor,
  iconBackground,
  image,
  courseID,
  activityID,
  uploadApiRoute,
  studentid,
}) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = (e, projectid) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    console.log("File Selected");
    handleUpload(file, projectid);
  };

  const handleUpload = async (file, projectID) => {
    setUploading(true);
    console.log("File Uploading");

    if (!file) {
      console.error("No file selected");
      setUploading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("Student_id", studentid);
    formData.append("Lesson_Project_id", projectID);

    // console.log("Form Data:");
    // for (const [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }

    const response = await fetch(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}${uploadApiRoute}`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (response.ok) {
      toast.success("Lesson Project Uploaded", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setSelectedFile(null);
    } else {
      console.error("Error uploading file");
    }

    setUploading(false);
  };

  const handleIconClick = (e, projectID) => {
    e.preventDefault();
    document.getElementById(`file-upload-${projectID}`).click();
  };

  const handleProjectClick = (projectType, projectID) => {
    // let route = "";
    // window.open(`${route}=${projectID}&studentid=${studentid}`, "_blank");
  };

  return (
    <div className="AP_ModuleProjectLesson" style={{ backgroundColor }}>
      <h2 className="AP_title" style={{ color: textColor }}>
        <img src={image} alt="" style={{ width: "7vh", height: "7vh" }} />{" "}
        {title}
      </h2>
      <ul className="AP_ActivitiesGrid">
        {projects.map((project, index) => (
          <li key={index} className="AP_Projects">
            <div className="AP_ProjectItem">
              <div style={{ marginBottom: "5px", position: "relative" }}>
                <Link
                  to=""
                  onClick={() =>
                    handleProjectClick(title, project.Lesson_Project_id)
                  }
                  style={{ marginRight: "7%", color: textColor }}
                >
                  {project.projectassignmentname}
                </Link>
                {project.MarksObtained > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      backgroundColor: "#4CAF50",
                      borderRadius: "50%",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "bold",
                      zIndex: 1,
                    }}
                  >
                    ✓
                  </span>
                )}
              </div>

              <div className="AP_ProjectDetails">
                <label
                  htmlFor={`file-upload-${project.Lesson_Project_id}`}
                  style={{ color: "green" }}
                >
                  <span
                    style={{
                      color: textColor,
                      backgroundColor: iconBackground,
                    }}
                    className="AP_Icon"
                    onClick={(e) =>
                      !uploading &&
                      handleIconClick(e, project.Lesson_Project_id)
                    }
                  >
                    <AiOutlineCloudUpload size={40} />
                  </span>
                  <input
                    id={`file-upload-${project.Lesson_Project_id}`}
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileSelect(e, project.Lesson_Project_id)
                    }
                    disabled={uploading}
                  />
                  Uploaded
                </label>

                <span className="AP_Score">
                  {project.MarksObtained}/{project.TotalMarks} (
                  {(
                    (project.MarksObtained / project.TotalMarks) *
                    100
                  ).toFixed()}
                  %)
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LessonProjects;
